var _rect, _circle, _path, _path2, _path3, _g, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorldwide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0397,
    cy: 40.237,
    r: 20.237,
    fill: "url(#paint0_linear_31265_494)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31265_494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 45,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0396 25.4182V20.4599C40.0396 20.2059 39.8378 19.9995 39.5838 20.0046C32.1914 20.1541 19.1133 23.9851 18.8858 41.6084C18.8825 41.8624 19.0887 42.0767 19.3427 42.0767H26.7016C26.9556 42.0767 27.1615 41.8708 27.1615 41.6168V36.838C27.1615 36.7201 27.2068 36.6067 27.288 36.5212L28.8748 34.8509C28.956 34.7655 29.0013 34.6521 29.0013 34.5342V33.338C29.0013 33.084 29.2072 32.8781 29.4612 32.8781H34.0605C34.3145 32.8781 34.5205 32.6721 34.5205 32.4181V29.3891C34.5205 29.2671 34.5689 29.1502 34.6552 29.0639L36.2255 27.4936C36.3117 27.4073 36.4287 27.3589 36.5507 27.3589H38.0166C38.1343 27.3589 38.2475 27.3138 38.333 27.2328L39.896 25.752C39.9877 25.6652 40.0396 25.5444 40.0396 25.4182Z",
    fill: "#8E8CEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3055 45.7672L31.076 42.2024C31.1614 42.1217 31.2744 42.0767 31.392 42.0767H33.0497C33.1672 42.0767 33.2802 42.1217 33.3656 42.2024L35.1234 43.8643C35.2088 43.945 35.3218 43.99 35.4394 43.99H39.1208C39.2383 43.99 39.3513 44.035 39.4367 44.1158L43.2182 47.6909C43.3036 47.7717 43.4166 47.8167 43.5342 47.8167H46.6422C46.987 47.8167 47.2092 48.1821 47.0505 48.4882L45.4264 51.6222C45.3925 51.6876 45.3749 51.7602 45.3749 51.8338V53.0967C45.3749 53.3507 45.1689 53.5566 44.9149 53.5566H43.5342C43.4166 53.5566 43.3036 53.6016 43.2182 53.6823L41.4714 55.3338C41.3795 55.4207 41.3275 55.5416 41.3275 55.668V57.1851C41.3275 57.3116 41.2754 57.4325 41.1835 57.5193L39.4477 59.1605C39.3558 59.2473 39.3038 59.3682 39.3038 59.4947V64.6434C39.3038 64.8698 39.139 65.0625 38.9154 65.0977L33.7642 65.9094C33.4851 65.9534 33.2327 65.7377 33.2327 65.4551V55.6877C33.2327 55.5098 33.1301 55.3479 32.9693 55.2718L29.3237 53.5485C29.2338 53.506 29.1601 53.4355 29.1137 53.3477L27.2149 49.7573C27.1799 49.691 27.1615 49.6172 27.1615 49.5423V46.1014C27.1615 45.975 27.2136 45.8541 27.3055 45.7672Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0559 27.3589H56.7523C59.0916 29.7199 63.3692 36.6679 61.7651 45.5722L59.76 47.5959L51.7396 39.5011V37.4774L49.7344 35.4537H47.7293L43.7191 33.43L43.7191 28.7755L45.0559 27.3589Z",
    fill: "#8E8CEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31265_494)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.0397,
    cy: 40.2371,
    r: 20.237,
    fill: "#8E8CEE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 39H26.1606C26.0602 39 25.9666 39.0501 25.9109 39.1336L24.0504 41.9244C24.0175 41.9737 24 42.0316 24 42.0908V43.7C24 43.8657 24.1343 44 24.3 44H25.8146C25.9282 44 26.0321 44.0642 26.0829 44.1658L26.848 45.696C26.9287 45.8574 27.1326 45.9116 27.2828 45.8115L29.7796 44.1469C29.9055 44.063 29.9492 43.8984 29.8816 43.7631L29.0829 42.1658C29.0321 42.0642 28.9282 42 28.8146 42H28.3C28.1343 42 28 41.8657 28 41.7V39.3C28 39.1343 27.8657 39 27.7 39Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31265_494",
    x1: 41.2402,
    y1: 39.308,
    x2: 61.2559,
    y2: 69.0415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#D2D1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldwide);
export default __webpack_public_path__ + "static/media/Worldwide.47abc38c1d4d660f70d2e274b6c5263e.svg";
export { ForwardRef as ReactComponent };